import { HOST_DOMAIN } from '@webapp/common/conf';

export const YM_COUNTER_ID = 26607360;

// Боевой счётчик включаем только для прод-домена: на test1..5 HOST_DOMAIN
// равен testN.ttgraf.ru, поэтому события со стейджей не попадают в боевую Метрику.
export const isYaMetrikaEnabled = HOST_DOMAIN === 'testograf.ru';

export const GOALS = {
    registrationConfirmed: 'registration-confirmed',
    demoSurveyCreated: 'demo-survey-created',
    licenseYearPaid: 'license-year-paid',
    licenseOncePaid: 'license-once-paid',
    licenseProPaid: 'license-pro-paid',
    surveyAnswer: 'otvet-na-opros',
    surveyAnswerPartial: 'otvet-na-opros-nezaversh',
} as const;

export type Goal = (typeof GOALS)[keyof typeof GOALS];

// Загрузчик tag.js нужен и на стейджах: через него работают счётчики клиентов
// в опросах. Инициализацию нашего счётчика добавляем только в prod.
const YaMetrikaTag = `
       (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
       m[i].l=1*new Date();
       for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
       k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
       (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
`;

const YaMetrikaInit = isYaMetrikaEnabled
    ? `
       window.__ttYmCounterInitialized = true;
       ym(${YM_COUNTER_ID}, "init", {
            clickmap:true,
            trackLinks:true,
            accurateTrackBounce:true
       });
`
    : '';

export const YaMetrikaCounter = `${YaMetrikaTag}${YaMetrikaInit}`;

// Для webpack-приложений (account, public-results), где нет next/head.
export const initYaMetrika = (): void => {
    if (!isYaMetrikaEnabled || typeof window === 'undefined' || window.__ttYmCounterInitialized) {
        return;
    }

    const script = document.createElement('script');
    script.textContent = YaMetrikaCounter;
    (document.head || document.documentElement).appendChild(script);
};

export function reachGoal(goal: Goal, params?: Record<string, unknown>, cb?: () => void): void {
    if (!isYaMetrikaEnabled || typeof window === 'undefined' || typeof window.ym !== 'function') {
        cb?.();
        return;
    }

    let done = false;

    const finish = () => {
        if (!done) {
            done = true;
            cb?.();
        }
    };

    try {
        window.ym(YM_COUNTER_ID, 'reachGoal', goal, params, finish);
    } catch (e) {
        console.warn('[metrika] reachGoal failed', e);
        finish();
        return;
    }

    // Страховка на случай, если tag.js не загрузился или заблокирован:
    // не держим редирект дольше секунды.
    if (cb) {
        setTimeout(finish, 1000);
    }
}

// SPA-переходы: Метрика сама шлёт хит только при загрузке страницы.
export const ymHit = (url?: string, referer?: string): void => {
    if (!isYaMetrikaEnabled || typeof window === 'undefined' || typeof window.ym !== 'function') {
        return;
    }

    try {
        window.ym(YM_COUNTER_ID, 'hit', url || window.location.href, referer ? { referer } : undefined);
    } catch (e) {
        console.warn('[metrika] hit failed', e);
    }
};
